/**
 * useMarketPlaceApp
 * @return the appSdk instance, appConfig and location after initialization
 */
import { MarketplaceAppContext, MarketplaceAppContextType } from "../contexts/marketplaceContext";
import { useContext, useMemo } from "react";

/**
 * Getter of appSdk instance, appConfig and location.
 */
export const useMarketPlaceApp = () => {
  const { appSdk, appConfig, appRegion } = useContext(MarketplaceAppContext) as MarketplaceAppContextType;

  /**
   * memoized locationName and location instance
   */
  const { locationName, location } = useMemo(() => {
    let location: any;
    let locationName: string = "";
    if (appSdk?.location) {
      const locationName = Object.keys(appSdk.location).find((key) => appSdk.location[key])
      if (locationName) {
        location = appSdk.location[locationName];
      }
    }
    return { location, locationName };
  }, [appSdk]);

  return { appSdk, appConfig, locationName, location, appRegion };
};